import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'SignupModal.title',
    description: 'Create Account Modal Header',
    defaultMessage: 'Create Account',
  },
  footerMain: {
    id: 'SignupModal.mainText',
    description: 'Signup Footer Additional Text',
    defaultMessage: 'Already have an account? ',
  },
  footerLink: {
    id: 'SignupModal.linkText',
    description: 'Signup Footer Sign In Link',
    defaultMessage: 'Sign In',
  },
  backBtn: {
    id: 'SignupModal.backBtn',
    description: 'Signup modal back button text',
    defaultMessage: 'Back',
  },
});
